export default function rateFilter (num) {
    if(typeof(num) !== "string"){
        return num
    }
    let a = typeof(num)
    num = Number(num).toString();
    // console.log(typeof num)
    if(num.indexOf(".") == -1){
        num = num + ".00"
    }
    let integer = num.slice(0,num.indexOf("."));
    let pointer = num.slice(num.indexOf(".")+1);
    if(pointer.length < 1){
        pointer = pointer + "00";
        return integer + "." + pointer
    }else if(pointer.length < 2){
        pointer = pointer + "0";
        return integer + "." + pointer
    }else if(pointer.length < 4){
        pointer = pointer;
        return integer + "." + pointer
    }else{
        pointer = pointer.slice(0,3);
        return integer + "." + pointer
    }
    return integer + "." + pointer
}


// WEBPACK FOOTER //
// ./src/modules/filter/rate.js